import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import '@excalidraw/excalidraw/index.css';
import { ThemeProvider } from './components/Layout/theme-provider';
import ToastContainer from './components/Common/ToastContainer';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import './i18n/config';
import { initBetterbugs } from './lib/betterbugs';
import { initFullstory } from './lib/fullstory';

initBetterbugs();
initFullstory();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem disableTransitionOnChange>
      <ErrorBoundary>
        <div className="min-h-screen bg-background">
          <App />
          <ToastContainer />
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);
